"use client";
import {
  __spreadProps,
  __spreadValues
} from "../../chunk-MMUBH76A.js";
import { Network, OnRampAsset, OnRampMethod, OnRampProvider } from "@getpara/core-sdk";
const PARA_CONNECT = "https://connect.getpara.com/";
const PARA_TERMS_AND_CONDITIONS = "https://getpara.com/terms";
const ON_RAMP_PROVIDERS = {
  [OnRampProvider.STRIPE]: {
    name: "Stripe",
    feeLower: 0.99,
    feeUpper: 4.49,
    methods: [OnRampMethod.ACH, OnRampMethod.DEBIT, OnRampMethod.CREDIT],
    icon: "stripeBrand",
    backgroundColors: ["#6772E5", "#808AF4"]
  },
  [OnRampProvider.RAMP]: {
    name: "Ramp",
    feeLower: 0.99,
    feeUpper: 4.49,
    methods: [OnRampMethod.ACH, OnRampMethod.DEBIT, OnRampMethod.CREDIT],
    icon: "rampNetworkBrand",
    backgroundColors: ["#21BF73", "#3AE492"]
  },
  [OnRampProvider.MOONPAY]: {
    name: "MoonPay",
    feeLower: 1,
    feeUpper: 4.5,
    methods: [OnRampMethod.ACH, OnRampMethod.DEBIT, OnRampMethod.CREDIT],
    icon: "moonpayBrand",
    backgroundColors: ["#7715F5", "#9647fd"]
  }
};
const ICON_TYPES = {
  ethereum: { isDark: true },
  usdcBrand: { isCircular: true },
  arbitrumBrand: { isCircular: true },
  baseBrand: { isCircular: true },
  optimismBrand: { isCircular: true },
  cosmos: { isCircular: true, isDark: true },
  celoBrand: { isCircular: true },
  tetherBrand: { isCircular: true }
};
const NETWORKS = Object.entries({
  [Network.ETHEREUM]: { name: "Ethereum", icon: "ethereum" },
  [Network.SEPOLIA]: { name: "Sepolia", icon: "ethereum" },
  [Network.ARBITRUM]: { name: "Arbitrum", icon: "arbitrumBrand" },
  [Network.BASE]: { name: "Base", icon: "baseBrand" },
  [Network.OPTIMISM]: { name: "Optimism", icon: "optimismBrand" },
  [Network.POLYGON]: { name: "Polygon", icon: "polygonBrand" },
  [Network.SOLANA]: { name: "Solana", icon: "solana" },
  [Network.COSMOS]: { name: "Cosmos", icon: "cosmos" },
  [Network.CELO]: { name: "Celo", icon: "celoBrand" },
  [Network.SOLANA_DEVNET]: { name: "Solana Devnet", icon: "solana" },
  [Network.NOBLE]: { name: "Noble", icon: "nobleBrand" }
}).reduce((acc, [key, entry]) => {
  return __spreadProps(__spreadValues({}, acc), {
    [key]: __spreadValues(__spreadValues({}, entry), ICON_TYPES[entry.icon])
  });
}, {});
const ON_RAMP_ASSETS = Object.entries({
  [OnRampAsset.ETHEREUM]: { name: "Ethereum", code: "ETH", icon: "ethereum" },
  [OnRampAsset.USDC]: { name: "USD Coin", code: "USDC", icon: "usdcBrand" },
  [OnRampAsset.POLYGON]: { name: "Polygon", code: "POL", icon: "polygonBrand" },
  [OnRampAsset.SOLANA]: { name: "Solana", code: "SOL", icon: "solana" },
  [OnRampAsset.ATOM]: { name: "Atom", code: "ATOM", icon: "cosmos" },
  [OnRampAsset.CELO]: { name: "Celo", code: "CELO", icon: "celoBrand" },
  [OnRampAsset.TETHER]: { name: "Tether", code: "USDT", icon: "tetherBrand" },
  [OnRampAsset.CUSD]: { name: "Celo Dollar", code: "CUSD", icon: "celoBrand" },
  [OnRampAsset.CEUR]: { name: "Celo Euro", code: "CEUR", icon: "celoBrand" },
  [OnRampAsset.CREAL]: { name: "Celo Real", code: "CREAL", icon: "celoBrand" }
}).reduce((acc, [key, entry]) => {
  return __spreadProps(__spreadValues({}, acc), {
    [key]: __spreadValues(__spreadValues({}, entry), ICON_TYPES[entry.icon])
  });
}, {});
function getNetworkName(str) {
  var _a, _b;
  return (_b = (_a = NETWORKS[str]) == null ? void 0 : _a.name) != null ? _b : `${str[0]}${str.slice(1).toLowerCase()}`;
}
function getNetworkIcon(str) {
  var _a, _b;
  return (_b = (_a = NETWORKS[str]) == null ? void 0 : _a.icon) != null ? _b : "globe";
}
function getAssetCode(str) {
  var _a, _b;
  return (_b = (_a = ON_RAMP_ASSETS[str]) == null ? void 0 : _a.code) != null ? _b : str;
}
function getAssetName(str) {
  var _a, _b;
  return (_b = (_a = ON_RAMP_ASSETS[str]) == null ? void 0 : _a.name) != null ? _b : str;
}
function getAssetIcon(str) {
  var _a, _b;
  return (_b = (_a = ON_RAMP_ASSETS[str]) == null ? void 0 : _a.icon) != null ? _b : "emptyCircle";
}
const MOBILE_SIZE = 480;
const NETWORK_NOT_SUPPORTED_ERROR = "network not supported";
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const BODY_MOTION_VARIANTS = {
  enter: (direction) => {
    return {
      scale: direction > 0 ? 0.9 : 1.1,
      opacity: 0
    };
  },
  center: {
    scale: 1,
    opacity: 1
  },
  exit: (direction) => {
    return {
      scale: direction < 0 ? 0.9 : 1.1,
      opacity: 0
    };
  }
};
const BODY_TRANSITION = {
  duration: 0.2
};
const SDK_VERSION = "1.14.0";
export {
  BODY_MOTION_VARIANTS,
  BODY_TRANSITION,
  EMAIL_REGEX,
  MOBILE_SIZE,
  NETWORKS,
  NETWORK_NOT_SUPPORTED_ERROR,
  ON_RAMP_ASSETS,
  ON_RAMP_PROVIDERS,
  PARA_CONNECT,
  PARA_TERMS_AND_CONDITIONS,
  SDK_VERSION,
  getAssetCode,
  getAssetIcon,
  getAssetName,
  getNetworkIcon,
  getNetworkName
};
